import { configureStore } from "@reduxjs/toolkit"
import storage from "redux-persist/lib/storage"
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist"
import thunk from "redux-thunk"
// import counterReducer from "../features/counter/counterSlice"
import cartApi from "src/features/checkout/cartJsApi"
import checkoutApi from "src/features/checkout/checkoutApi"
import storefrontApi from "src/features/checkout/storefrontApi"
import storefrontCartApi from "src/features/checkout/storefrontCartApi"
import checkoutReducer from "src/features/checkout/checkoutSlice"

const persistConfig = {
  key: "checkoutV2",
  storage,
  whitelist: ["options", "appliedGiftCards"],
}

const persistedCheckoutReducer = persistReducer(persistConfig, checkoutReducer)

export const store = configureStore({
  reducer: {
    [cartApi.reducerPath]: cartApi.reducer,
    [checkoutApi.reducerPath]: checkoutApi.reducer,
    [storefrontApi.reducerPath]: storefrontApi.reducer,
    [storefrontCartApi.reducerPath]: storefrontCartApi.reducer,
    // counter: counterReducer,
    checkout: persistedCheckoutReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(thunk)
      .concat(cartApi.middleware)
      .concat(checkoutApi.middleware)
      .concat(storefrontApi.middleware)
      .concat(storefrontCartApi.middleware),
})

export const persistor = persistStore(store)
